export const formatCurrency = (value: number|string, currency: string) => {
	try {
		return new Intl.NumberFormat('en', {style: 'currency', currency, minimumFractionDigits: +value % 1 === 0 ? 0 : 2}).format(+value)
	} catch (e) {
		if(value && currency){
			return `${new Intl.NumberFormat('en', {minimumFractionDigits: +value % 1 === 0 ? 0 : 2}).format(+value)} ${currency}`
		} else {
			return value
		}
	}
}